import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesItem',
  props: {
    span: { default: 1 }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "e3b325a8": (props.span)
}))

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select'))),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('select')), ["space","enter"])),
    tabindex: "0"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}
}

})